import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { LinearProgress, LinearProgressProps } from '@rmwc/linear-progress';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import close from 'four-nets/icons/svg/icon_close.svg';
import refresh from 'four-nets/icons/svg/icon_refresh.svg';

import '@rmwc/linear-progress/styles';
import defaultStyles from './upload.scss';

export interface Props extends LinearProgressProps {
    onRetry?: React.MouseEventHandler<HTMLButtonElement>;
    onClose?: React.MouseEventHandler<HTMLButtonElement>;
    error?: Error | null;
    errorMessage: React.ReactNode;
    styles: typeof defaultStyles;
}

class Upload extends React.PureComponent<Props> {
    static defaultProps = {
        errorMessage: <FormattedMessage id='LABEL_UPLOAD_FAILED'></FormattedMessage>,
    };

    render() {
        const { styles, error, children, errorMessage, onClose, onRetry, ...rest } = this.props;

        return (
            <div className={styles.upload}>
                {children}
                <div className={styles.ui}>
                    <div className={styles.actions}>
                        {onClose ? (
                            <button type='button' className={styles.close} onClick={onClose}>
                                <span>
                                    <SVGIcon style={{ image: styles.icon }} src={close} />
                                </span>
                            </button>
                        ) : null}
                    </div>
                    <div className={styles.messages}>
                        {error ? (
                            <FormattedMessage id='BUTTON_LABEL_RETRY_FAILED'>
                                {msg => (
                                    <React.Fragment>
                                        <span className={styles.error}>{errorMessage}</span>
                                        <SVGIcon style={{ image: styles.icon }} src={refresh} />
                                        <button
                                            type='button'
                                            className={styles.retry}
                                            title={msg as string}
                                            onClick={onRetry}
                                        />
                                    </React.Fragment>
                                )}
                            </FormattedMessage>
                        ) : null}
                        {!children && !error ? (
                            <div className={styles.progress}>
                                <LinearProgress {...rest} className={styles.linearProgress}></LinearProgress>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

export default Styled(defaultStyles)(Upload);
